import { Box } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import InceptionLogo from "../../assets/Inception Program.svg";
import GoogleLogo from "../../assets/googleStartup.png";
import MicrosoftLogo from "../../assets/MS_Startups_Celebration_Badge_Light.png";
import AwsLogo from "../../assets/aws_startup.png";
import IbmLogo from "../../assets/ibm_partner.png";

const logos = [
  { id: 1, name: "inception", path: InceptionLogo },
  { id: 2, name: "googleStartup", path: GoogleLogo },
  { id: 3, name: "microSoft", path: MicrosoftLogo },
  { id: 4, name: "awsStartup", path: AwsLogo },
  { id: 5, name: "ibmStartup", path: IbmLogo },
];

const PartnerCorousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 5000,
    autoplaySpeed: 500,
    cssEase: "linear",
    centerMode: false,
    variableWidth: true,
    responsive: [
      { breakpoint: 900, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <Box
      sx={{
        overflow: "hidden",
        "& .slick-track": {
          display: "flex",
          alignItems: "center",
        },
        "& .slick-slide": {
          float: "none",
          height: "auto",
        },
        "& .slick-slide > div": {
          display: "flex",
          justifyContent: "center",
        },
      }}
    >
      <Slider {...settings}>
        {logos.map((item) => (
          <Box
            key={item.id}
            sx={{
              px: { xs: 2, md: 4 },
              boxSizing: "border-box",
              width: { xs: 160, sm: 200, md: 232 },
            }}
          >
            <Box
              component="img"
              src={item.path}
              alt={item.name}
              sx={{
                height: { xs: 70, sm: 85, md: 100 },
                width: "auto",
                maxWidth: { xs: 140, sm: 170, md: 200 },
                objectFit: "contain",
                display: "block",
                mx: "auto",
              }}
            />
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default PartnerCorousel;
